export default __webpack_public_path__ + "static/media/facebook-letter.acd66cb0.svg";